import React, { useEffect, useContext, useState } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { string, object, bool, func } from 'prop-types';
import { RecommendationsPlaceholder, RecommendationsProvider } from '@thd-olt-component-react/recommendations';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import {
  NewNoResultsFoundBanner,
  NoResultsFoundBanner
} from '@thd-olt-component-react/no-results-found-banner';
import { Row, Col } from '@thd-olt-component-react/grid';
import { RelatedSearch } from '@thd-olt-component-react/related-search';
import { NewShopByCategory } from '@thd-olt-component-react/shop-by-category';

const NoResultsFound = ({
  keyword, recommendationsCtx, searchData, searchError, searchLoading, storeId, cpoOnly, onCpoClick
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('no-results-found.ready'); }, []);

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const [searchCookie, setSearchCookie] = useState('');
  const searchOptions = searchCookie.split(',');
  const enableExtraComponents = searchOptions.filter((opt) => opt === 'nrf').length === 1;

  const crumbs = [
    { label: 'Text Search', url: '' },
    { label: keyword, url: `/s/${keyword}?NCNI-5` }
  ];

  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
      LIFE_CYCLE_EVENT_BUS.trigger('no-results.loaded', { keyword });
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setSearchCookie(window.cookieUtils?.readBrowserCookie('x-ttsearch') || '');
    }
  }, [searchCookie]);

  return (
    <RecommendationsProvider resx={recommendationsCtx}>
      <Row className="isBound">
        <Col xs="12" sm="12" md="12">
          <Breadcrumbs staticCrumbs={crumbs} hideOnNoCategory={isMobile} />
          {!enableExtraComponents
          && <NoResultsFoundBanner keyword={keyword} cpoOnly={cpoOnly} onCpoClick={onCpoClick} />}
          {enableExtraComponents && (
            <>
              <NewNoResultsFoundBanner keyword={keyword} cpoOnly={cpoOnly} onCpoClick={onCpoClick} />
              {searchData && (
                <RelatedSearch
                  searchData={searchData}
                  searchError={searchError}
                  searchLoading={searchLoading}
                  storeId={storeId}
                />
              )}
              <RecommendationsPlaceholder scheme="searchViewed" />
              <NewShopByCategory />
              <RecommendationsPlaceholder scheme="no_results_found_sponsored" />
            </>
          )}
        </Col>
      </Row>
    </RecommendationsProvider>
  );
};

NoResultsFound.displayName = 'NoResultsFound';

NoResultsFound.propTypes = {
  keyword: string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  recommendationsCtx: object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  searchData: object,
  // eslint-disable-next-line react/forbid-prop-types
  searchError: object,
  searchLoading: bool,
  storeId: string,
  cpoOnly: bool,
  onCpoClick: func
};

NoResultsFound.defaultProps = {
  searchData: undefined,
  searchError: undefined,
  searchLoading: undefined,
  storeId: null,
  cpoOnly: false,
  onCpoClick: () => {},
};

export { NoResultsFound };
